import Modal from "react-modal";
import { Action, BarSearch, ColumnItems, ColumnLeft, Container, Contents, FileItem, ListFiles, ListSelected, Title, TitleText } from "./styled";
import { useEffect, useRef } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { ArrowTopRightOnSquareIcon, CloudArrowUpIcon, CodeBracketIcon, DocumentIcon, FilmIcon, LockClosedIcon, PhotoIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { border } from "polished";
import IconImage from "../../../../assets/imgs/icons/image.svg";

import IconUrl from "../../../../assets/imgs/icons/code.svg";
import IconDefault from "../../../../assets/imgs/icons/default.svg"
import IconVideo from "../../../../assets/imgs/icons/videoplay.svg";
import IconPdf from "../../../../assets/imgs/icons/pdf.svg";

import axios from 'axios';
import { IconFile } from "../card-product/styled";
import { VscSearch } from "react-icons/vsc";
import LoadingLogo from "../../../../components/Loading-logo";
import PaginationModalFiles from "../tailwind/pagination-modal-files";
import PaginationModaLicenses from "../tailwind/pagination-modal-licenses";

const customStyles = {
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        width: "600px",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
        backgroundColor: "transparent",
        padding: "0px",
        margin: "0px",
        borderRadius: "8px",
        border: "none"
    },
    overlay: {
        backgroundColor: "rgba(10,23,55,0.5)",
        zIndex: "99999999"
    },
};



const ModalAnexarLIcenses = (props) => {

    //const [files, setFiles] = useState([])
    const dispatch = useDispatch()
    const reducerControlVariants = useSelector(state => state.reducerControlVariants)
    const medias = useSelector((state) => state.reducerLicenses);
    const language = useSelector((state) => state.reducerLanguage);
    const { id } = useParams();


    const closeModal = () => {
        props.handleClick()
        setTimeout(() => {
            props.setVisible(false)
            dispatch({ type: "VARIANTS_CONTROL_RESET" });
            if (props?.close) {
                props.close()
            } else {
                //dispatch({ type: "SAGA_LIST_VARIANTS", payload: id, });
                props.goSearch()
            }
        }, 100);

    }

    useEffect(() => {
        //console.log("reducerControlVariants", reducerControlVariants)
    }, [reducerControlVariants])





    useEffect(() => {
       console.log("licenses teste", medias)
    }, [medias])


    const changePage = (page) => {
        console.log("changePage: ", page)
        props.setPageFiles(page)
    }

    return (
        <Modal
            isOpen={props.visible}
            style={customStyles}
            ariaHideApp={false}
            onRequestClose={() => { }}
        >
            <Container>
                <Title>
                    <div>
                        <label>Anexar Licenças</label>
                        <XMarkIcon onClick={() => { closeModal() }} style={{ cursor: "pointer" }} width={20} />
                    </div>
                    <label >
                        Pesquise a licença e clique em anexar.
                    </label>
                </Title>
                <Contents>

                    <ColumnLeft>

                        {medias?.loading == true ?
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <LoadingLogo />
                            </div> :
                            <>
                                <BarSearch>
                                    <input
                                        value={props.searchFiles}
                                        onChange={(e) => { props.setSearchFiles(e.target.value) }}
                                        placeholder="Buscar..."
                                    />
                                    <div onClick={() => {
                                        props.goSearchFiles()
                                    }}>
                                        <VscSearch size={20} color={"#ffffff"} />
                                    </div>
                                </BarSearch>

                                <TitleText>Lista de licenças</TitleText>

                                <ListFiles>
                                    {medias?.data?.data?.map((file) => {
                                        return (
                                            <CardFile setDataFilesTrue={props.setDataFilesTrue} dataFilesTrue={props.dataFilesTrue} file={file} />
                                        )
                                    })}

                                </ListFiles>
                                <PaginationModaLicenses
                                    setPage={changePage}
                                />
                            </>
                        }
                    </ColumnLeft>

                </Contents>
            </Container>

        </Modal >
    )
}

export default ModalAnexarLIcenses




const CardFile = (props) => {

    const [loading, setLoading] = useState(false)
    const reducerControlVariants = useSelector(state => state.reducerControlVariants)

    useEffect(() => {
        console.log("CardFilelicense props", props)
    }, [props])


    const anexarFile = async () => {

        setLoading(true)

        const token = JSON.parse(localStorage.getItem("depoimentos@login"))?.access_token.token;
        const url = `${process.env.REACT_APP_API_URL}/variant_link_license`;
        const headers = new Headers({ 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' });

        await Promise.all(
            reducerControlVariants.data.map((variant) => {
                //console.log("variant", variant);

                return fetch(url, {
                    method: 'POST',
                    headers: headers,
                    body: JSON.stringify({ license_id: props.file.id,  variant_id: variant.variants.id })
                })
                    .then(response => {
                        if (!response.ok) {
                            throw new Error(`Erro na requisição para variante ${variant.variant_id}: ${response.statusText}`);
                        }
                        //console.log("response", response)
                        return response.json();
                    })
            })
        );

        setLoading(false)
        //props.setDataFilesTrue([...props.dataFilesTrue, props.file])
        console.log("props.file", props.file) 
        props.setDataFilesTrue(prevData => [...prevData, {license: props.file}]);
    }

    const verify = () => {
        return props.dataFilesTrue.some(existingMedia => existingMedia.license.id === props.file.id);
    }

    return (
        <FileItem>
            <div>
                <CodeBracketIcon style={{width: "20px"}} color={"#1F2937"}  />
                <label style={{ fontSize: "14px", display: "flex", maxWidth: "400px", wordBreak: 'break-all' }}>{
                    props.file.name}
                </label>
            </div>
            <Action disable={verify()} onClick={() => { !verify() && anexarFile() }} className={verify() ? "bg-gray-200" : "bg-green-600"}>
                {loading ? "Anexando..." : verify() ? "Anexado" : "Anexar"}
            </Action>
        </FileItem>
    )
}